import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, getParam, getId } from "./reportDetailApi";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  statusParam: [],
  reasonParam: [],
  stepParam: [],
};

export const fetchAll = createAsyncThunk(
  "reportDetail/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const fetchStatusParam = createAsyncThunk(
  "reportDetail/fetchStatusParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);
export const fetchStepParam = createAsyncThunk(
  "reportDetail/fetchStepParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const fetchReasonParam = createAsyncThunk(
  "reportDetail/fetchReasonParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const fetchDetailId = createAsyncThunk(
  "reportDetail/fetchDetailId",
  async (payload) => {
    const response = await getId(payload);
    return response;
  }
);

export const reportDetailSlice = createSlice({
  name: "reportDetail",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchDetailId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDetailId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data[0];
      })
      .addCase(fetchStatusParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStatusParam.fulfilled, (state, action) => {
        state.loading = false;
        state.statusParam = action.payload.data;
      })
      .addCase(fetchReasonParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReasonParam.fulfilled, (state, action) => {
        state.loading = false;
        state.reasonParam = action.payload.data;
      })
      .addCase(fetchStepParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStepParam.fulfilled, (state, action) => {
        state.loading = false;
        state.stepParam = action.payload.data;
      });
  },
});

export const { resetData, setSelected } = reportDetailSlice.actions;

export const selectData = (state) => state.reportDetail.data;
export const selectDataId = (state) => state.reportDetail.dataId;
export const selectLoading = (state) => state.reportDetail.loading;
export const selectError = (state) => state.reportDetail.error;
export const selectPageNo = (state) => state.reportDetail.pageNo;
export const selectPageSize = (state) => state.reportDetail.pageSize;
export const selectTotalRecord = (state) => state.reportDetail.totalRecord;
export const selectSelected = (state) => state.reportDetail.selected;
export const selectStatusParam = (state) => state.reportDetail.statusParam;
export const selectReasonParam = (state) => state.reportDetail.reasonParam;
export const selectStepParam = (state) => state.reportDetail.stepParam;

export default reportDetailSlice.reducer;
